export default __webpack_public_path__ + "pi1-1QAAT/images/lock-icon-53827a5d3338fada09ecd706df7b7800.svg";